// ============================================================================
// OBT F2-B — Cevap akışı enum/etiket sabitleri (paket-yerel)
// ============================================================================
// Ortak `obtEnums.js` yalnız READ-ONLY import edilir (değiştirilmez). Buradaki
// tanımlar F2-B'ye özeldir. Backend'de OLMAYAN durum/soru tipi İCAT EDİLMEZ.
// ============================================================================

import {
  RESPONSE_STATUS_LABELS,
  SUGGESTED_PARK_STATUS_LABELS,
  QUESTION_TYPE_LABELS,
  obtLabel,
  obtTone,
} from '../obtEnums';

export { RESPONSE_STATUS_LABELS, SUGGESTED_PARK_STATUS_LABELS, QUESTION_TYPE_LABELS };

/** enums.py :: ResponseStatus (birebir). */
export const RESPONSE_STATUS = Object.freeze({
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  REVISION_REQUESTED: 'revision_requested',
  RESUBMITTED: 'resubmitted',
});

/** Cevabın düzenlenebildiği durumlar (backend _EDITABLE_RESPONSE_STATUSES). */
export const EDITABLE_RESPONSE_STATUSES = Object.freeze([
  RESPONSE_STATUS.DRAFT,
  RESPONSE_STATUS.REVISION_REQUESTED,
]);

/** Salt-okunur (kilitli) durumlar. */
export const LOCKED_RESPONSE_STATUSES = Object.freeze([
  RESPONSE_STATUS.SUBMITTED,
  RESPONSE_STATUS.RESUBMITTED,
]);

export function isEditableStatus(status) {
  return EDITABLE_RESPONSE_STATUSES.includes(status);
}
export function isLockedStatus(status) {
  return LOCKED_RESPONSE_STATUSES.includes(status);
}

/** enums.py :: QuestionType (birebir). */
export const QUESTION_TYPE = Object.freeze({
  BOOLEAN: 'boolean',
  TEXT: 'text',
  SINGLE_SELECT: 'single_select',
  MULTI_SELECT: 'multi_select',
  PHOTO: 'photo',
  DOCUMENT: 'document',
});

export const SELECT_TYPES = Object.freeze([
  QUESTION_TYPE.SINGLE_SELECT,
  QUESTION_TYPE.MULTI_SELECT,
]);

export function questionNeedsOptions(type) {
  return SELECT_TYPES.includes(type);
}
export function isDocumentQuestion(type) {
  return type === QUESTION_TYPE.DOCUMENT;
}
export function isPhotoQuestion(type) {
  return type === QUESTION_TYPE.PHOTO;
}

// Belge yükleme HTTP ucu YOK → document sorusu cevaplanamaz (talimat §10).
export const DOCUMENT_UNSUPPORTED_NOTE =
  'Belge yükleme desteği henüz kullanıma açık değildir. Bu soru şu anda cevaplanamaz.';

// Kayıtlı cevap içeriği geri okunamaz (backend owner-detay ucu yok) uyarısı.
export const ANSWER_READBACK_NOTE =
  'Bu cevabın önceki içeriği mevcut arayüzde yeniden gösterilemiyor; ' +
  'durum ve sayaç bilgileri gösterilir.';

export function responseStatusLabel(status) {
  return obtLabel(RESPONSE_STATUS_LABELS, status, 'Cevap Bekliyor');
}
export function suggestedParkStatusLabel(status) {
  return obtLabel(SUGGESTED_PARK_STATUS_LABELS, status);
}
export function questionTypeLabel(type) {
  return obtLabel(QUESTION_TYPE_LABELS, type);
}
export function statusTone(status) {
  return obtTone(status);
}

// ---------------------------------------------------------------------------
// Görev listesi filtre kategorileri — YALNIZ backend sayaçlarından türetilir.
// ---------------------------------------------------------------------------

export const TASK_FILTERS = Object.freeze([
  { key: 'all', label: 'Tümü' },
  { key: 'pending', label: 'Cevap Bekleyenler' },
  { key: 'drafts', label: 'Taslaklar' },
  { key: 'revision', label: 'Revizyon İstenenler' },
  { key: 'submitted', label: 'Gönderilmişler' },
  { key: 'late', label: 'Süresi Geçenler' },
]);

/**
 * Bir publication verilen kategoriye giriyor mu? Bir publication birden fazla
 * kategoriye girebilir (aynı yayında hem taslak hem revizyon olabilir).
 */
export function publicationMatchesFilter(pub, filterKey) {
  if (!pub) return false;
  const parks = pub.my_park_count ?? 0;
  const answered = pub.my_answered_count ?? 0;
  const drafts = pub.my_draft_count ?? 0;
  const submitted = pub.my_submitted_count ?? 0;
  const revision = pub.my_revision_count ?? 0;
  switch (filterKey) {
    case 'all':
      return true;
    case 'pending':
      // Cevaplanmamış (kaydı olmayan) parkı olan yayınlar.
      return parks > answered;
    case 'drafts':
      return drafts > 0;
    case 'revision':
      return revision > 0;
    case 'submitted':
      return submitted > 0;
    case 'late':
      return Boolean(pub.due_passed);
    default:
      return true;
  }
}
